import { render, staticRenderFns } from "./DescriptorsContainer.vue?vue&type=template&id=2d3211f1&scoped=true"
import script from "./DescriptorsContainer.vue?vue&type=script&lang=js"
export * from "./DescriptorsContainer.vue?vue&type=script&lang=js"
import style0 from "./DescriptorsContainer.vue?vue&type=style&index=0&id=2d3211f1&prod&scoped=true&lang=css"
import style1 from "./DescriptorsContainer.vue?vue&type=style&index=1&id=2d3211f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3211f1",
  null
  
)

export default component.exports